module.exports = __webpack_public_path__ + "static/media/linkedin.5388e769.svg";